"use client";

import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { MessageSquare, PhoneCall, ArrowRight } from "lucide-react";

export function Contact() {
  return (
    <section id="contact" className="py-24 relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gradient-to-r from-transparent via-[#C9956B]/40 to-transparent" />

      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-5xl mx-auto rounded-2xl border border-white/[0.06] bg-white/[0.02] overflow-hidden flex flex-col lg:flex-row"
        >
          {/* Left Column */}
          <div className="w-full lg:w-5/12 p-8 lg:p-10 bg-white/[0.01] border-b lg:border-b-0 lg:border-r border-white/[0.06] flex flex-col justify-between">
            <div>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-emerald-500/10 border border-emerald-500/20 mb-6">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
                <span className="text-[11px] font-medium text-emerald-400 uppercase tracking-widest">
                  Online agora
                </span>
              </span>

              <h3 className="text-2xl md:text-3xl font-bold mb-4 leading-tight">
                Pronto para elevar sua presença digital?
              </h3>
              <p className="text-[14px] text-zinc-500 mb-8 leading-relaxed">
                Deixe seus dados abaixo ou nos chame direto no WhatsApp. Analisamos seu cenário e marcamos uma consultoria sem compromisso.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3 group cursor-pointer">
                <div className="w-10 h-10 rounded-lg bg-white/[0.05] border border-white/[0.06] flex items-center justify-center group-hover:bg-[#C9956B]/10 transition-colors">
                  <PhoneCall className="w-4.5 h-4.5 text-[#D4A574]" />
                </div>
                <div>
                  <p className="text-[11px] text-zinc-600 uppercase tracking-wider">Telefone</p>
                  <p className="text-[14px] font-medium text-zinc-300">+55 (11) 99999-9999</p>
                </div>
              </div>

              <Button className="w-full bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-lg h-11 flex items-center justify-center gap-2 text-[14px] font-medium transition-colors">
                <MessageSquare className="w-4.5 h-4.5" />
                Chamar no WhatsApp
              </Button>
            </div>
          </div>

          {/* Right Column — Form */}
          <div className="w-full lg:w-7/12 p-8 lg:p-10">
            <h4 className="text-lg font-semibold mb-6">Envie uma mensagem</h4>
            <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <Label htmlFor="name" className="text-[13px] text-zinc-500">
                    Nome Completo
                  </Label>
                  <Input
                    id="name"
                    placeholder="João Silva"
                    className="bg-white/[0.03] border-white/[0.08] text-white h-10 rounded-lg focus-visible:ring-1 focus-visible:ring-[#C9956B] px-3.5 text-[14px] placeholder:text-zinc-700"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label htmlFor="company" className="text-[13px] text-zinc-500">
                    Empresa
                  </Label>
                  <Input
                    id="company"
                    placeholder="Sua Empresa"
                    className="bg-white/[0.03] border-white/[0.08] text-white h-10 rounded-lg focus-visible:ring-1 focus-visible:ring-[#C9956B] px-3.5 text-[14px] placeholder:text-zinc-700"
                  />
                </div>
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="email" className="text-[13px] text-zinc-500">
                  E-mail Profissional
                </Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="joao@empresa.com.br"
                  className="bg-white/[0.03] border-white/[0.08] text-white h-10 rounded-lg focus-visible:ring-1 focus-visible:ring-[#C9956B] px-3.5 text-[14px] placeholder:text-zinc-700"
                />
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="message" className="text-[13px] text-zinc-500">
                  Como podemos ajudar?
                </Label>
                <Textarea
                  id="message"
                  placeholder="Conte sobre o seu negócio e seus objetivos..."
                  className="min-h-[100px] bg-white/[0.03] border-white/[0.08] text-white rounded-lg focus-visible:ring-1 focus-visible:ring-[#C9956B] p-3.5 text-[14px] resize-none placeholder:text-zinc-700"
                />
              </div>
              <Button
                type="submit"
                className="w-full rounded-lg h-11 text-[14px] font-medium bg-[#C9956B] hover:bg-[#D4A574] text-[#0a0a0a] transition-colors mt-2"
              >
                Solicitar Contato
                <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
